import { jsonMember, jsonObject } from 'typedjson';
import { Uuid } from '@core/uuid/uuid';

@jsonObject
export class OfferSharePreviewResponse {
  @jsonMember readonly id!: Uuid;
  @jsonMember readonly content!: string;
}
